import { track } from '@betterment/js-runtime';
import { Controller } from '@hotwired/stimulus';

import ReturnsGraph, { ReturnsGraphOptions } from '../graphs/returns-graph';
import { parseInteger } from '../models/helpers';

export default class extends Controller {
  static targets = ['svg'];

  svgTarget: SVGElement;

  resizeListener: () => void;

  connect() {
    this.draw();
    this.connectResizeListener();
  }

  disconnect() {
    this.disconnectResizeListener();
  }

  draw() {
    const chart = new ReturnsGraph(this.svgTarget, this.graphOptions);
    chart.draw();
  }

  connectResizeListener() {
    this.resizeListener = this.draw.bind(this);
    window.addEventListener('resize', this.resizeListener);
  }

  mouseLeave() {
    this.trackHover();
  }

  onClick() {
    this.trackClick();
  }

  trackHover() {
    track('ElementHovered', { name: 'ProjectionGraph', location: this.data.get('tracking-location')! });
  }

  trackClick() {
    track('ElementClicked', { name: 'ProjectionGraph', location: this.data.get('tracking-location')! });
  }

  disconnectResizeListener() {
    window.removeEventListener('resize', this.resizeListener);
  }

  get graphOptions(): ReturnsGraphOptions {
    const requiredOptions = {
      minValue: this.data.get('min-value') ? parseFloat(this.data.get('min-value')!) : 0,
      maxValue: this.data.get('max-value') ? parseFloat(this.data.get('max-value')!) : 0,
      termYears: this.data.get('term-years') ? parseInteger(this.data.get('term-years')!) : 0,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      valuesByDate: this.data.get('values-by-date') ? JSON.parse(this.data.get('values-by-date')!) : {},
    };

    return {
      ...requiredOptions,
      ...(this.data.get('display-y-axis') && { displayYAxis: this.data.get('display-y-axis') === 'true' }),
      ...(this.data.get('aspect-ratio') && { aspectRatio: parseFloat(this.data.get('aspect-ratio')!) }),
    };
  }
}
